import React, { useEffect, useState } from 'react';
import * as styles from './contactForm.module.scss';
import Email from '../../assets/svg/email.svg';
import Location from '../../assets/svg/location.svg';
import Phone from '../../assets/svg/phone.svg';
import { Helmet } from 'react-helmet';

export const ContactForm = ( {carelineScript, subHeading} : any) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  useEffect(() => {
    if (!document) {
      return;
    }
    const contactUs = document.createElement('script');
    //contactUs.src = 'https://d1a1ax4tcp3m3j.cloudfront.net/preprod-dev/TWH/nl-nl/BZA325/nl-nl_BZA325.js';
    contactUs.src = carelineScript;
    contactUs.async = true;
    document.body.appendChild(contactUs);

    return () => {
      document.body.removeChild(contactUs);
    }
  })
  
  return (
    <div className={`container container-md ${styles.contactForm}`}>
      <div className={styles.contactFormWrapper}>
        <h2 className="heading heading-2">{subHeading}</h2>
        <div className="container" >
          <div className='contact-form'>
            <section className='contact-us-twh-generic'>
              <form>
               
              </form>
            </section>
          </div>
          </div>
          {/* <div className='fw-content-container' /> */}
      </div>
    </div>
  )
}

